import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Settings } from "react-feather";
import Highlighter from "react-highlight-words";
import { Card, CardBody } from "reactstrap";
import { H5 } from "../../../AbstractElements";

import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tag,
  Upload,
} from "antd";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import {
  BulkUploadVendorApi,
  PaginatedVendorApi,
  VendorApi,
} from "../../../api";
import SearchFilterDirectory from "./searchFilterDirectory";
import UploadResultTable from "./uploadResultTable";

import { SearchOutlined } from "@ant-design/icons";
import { LogEvents, LoggerContext } from "../../../context/logging";
import { vendorCreationAndEditGranted } from "../../../utils/PermissionFunctions/userPermissions";
import { getTableHeight } from "../../../utils/TableHelpers/TableHeightHelper";
import ColumnConfig from "../Project/Budget/column-config";
import EmpaneledVendors from "./empaneledVendors";
import { VendorCatalogue } from "./vendorCatalogue";
import { VendorDetails } from "./VendorDetails";
import VendorSearch from "./vendorSearch";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ContainerUpload = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #e8e8e8;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

export function StyledDropzone(props) {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone();
  useEffect(() => {
    if (acceptedFiles.length > 0) props.setFile(acceptedFiles[0]);
  }, [acceptedFiles]);
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <div className="container">
      <ContainerUpload
        {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
      >
        <input {...getInputProps()} />
        <div style={{ height: 120 }}>
          <p style={{ marginTop: 40, textAlign: "center" }}>
            Bulk Upload files.
            <br /> Drag and drop your file here, or click to select.
          </p>
        </div>
      </ContainerUpload>
    </div>
  );
}
const Vendor = (props) => {
  const { Search } = Input;
  const logger = React.useContext(LoggerContext);

  const [vendorListEmpaneled, setVendorListEmpaneled] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [financial, setFinancial] = useState(false);
  const [editId, setEditId] = useState(null);
  const childRef = useRef();
  const [category, setCategory] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [empaneled, setEmpaneled] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [categories, setCategories] = useState([]);
  const [search, setsearch] = useState(false);
  const [totalVendorPages, setTotalVendorPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [filterValues, setFilterValues] = useState({
    vendor_code: [],
    vendor_categories: [],
    email_id: [],
    pincode: [],
  });
  const [selectedVendorCatalogue, setSelectedVendorCatalogue] = useState(null);
  const [showContactDetails, setShowContactDetails] = useState(true);

  const [selectedVendor, setSelectedVendor] = useState(null);

  const [headpinCode, setHeadPinCode] = useState("560102");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [headkm, setHeadkm] = useState("5000");

  const [vendorSearchParams, setVendorSearchParams] = useState({
    page: 1,
  });

  const inputRef = useRef(null);
  const { Dragger } = Upload;
  const { Option } = Select;
  const showDrawer = () => {
    setVisible(true);
  };
  const formRef = useRef();
  const onClose = () => {
    setCategory([]);
    setEditId(null);
    formRef.current.resetFields();
    setVisible(false);
    setFinancial(false);
  };
  const fetchVendorsDirectory = (params = {}) => {
    // setLoading(true);
    console.log("fetchVendorsDirectory", params);
    let params_for_api = {
      ...params,
      km: headkm,
      pincode: headpinCode,
    };
    if (selectedCategories?.length > 0) {
      params_for_api.category = selectedCategories?.toString();
    }
    if (empaneled) {
      axios
        .get(
          `https://apivendor.materialdepot.in/apiV1/vendor-data/?api_key=d278afe1-2303-421e-b1a2-8f2d764c6e20`,
          {
            params: params_for_api,
            headers: "",
          }
        )
        .then((res) => {
          setTotalPages(res?.data?.count);
          setVendorListEmpaneled(res.data?.data);
        });
    } else {
      setLoading(false);
    }
  };

  const fetchVendors = (params = {}) => {
    setLoading(true);
    // axios
    //   .get(`${VendorApi}`, {
    //     params: { ...params, branch: props?.settings?.branch?.id },
    //   })
    //   .then((res) => {
    //     setLoading(false);
    //     setVendorList(res.data);
    //     setTotalVendors(res?.data?.count);
    //     // console.log(res.data, "User");
    //   })
    //   .catch(() => {
    //     toast.error("Something went wrong!");
    //   });
    axios
      .get(`${PaginatedVendorApi}`, {
        params: {
          branch: props?.settings?.branch?.id,
          ...vendorSearchParams,
          ...params,
        },
      })
      .then((res) => {
        setVendorList(res.data?.results);
        setTotalVendorPages(res?.data?.count ?? 10);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchcategories = () => {
    axios.get("apiV1/organisation-item-category/").then((res) => {
      setCategories(res.data);
    });
  };

  const onSearch = (params = {}) => {
    logger.log(LogEvents.searchVendor, {});
    fetchVendors(params);
  };

  useEffect(() => {
    fetchVendors();
    fetchVendorsDirectory();
  }, [empaneled]);

  const AddVendor = () => {
    logger.log(LogEvents.vendorSubmit, {});
    const updatedValues = formRef.current.getFieldsValue();
    console.log("updatedValues", updatedValues);
    if (
      updatedValues?.name &&
      updatedValues?.contact?.toString()?.match(/^\d{10}$/) &&
      updatedValues?.email?.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      ) &&
      updatedValues?.pincode?.match(/^\d{6}$/)
    ) {
      const values = new FormData();
      // if (tags.length > 0) {
      //   values.append("vendor_type", JSON.stringify(tags));
      // } else {
      //   values.append("vendor_type", JSON.stringify([]));
      // }
      values.append("name", updatedValues.name);
      values.append(
        "vendor_code",
        updatedValues.vendor_code ? updatedValues.vendor_code : ""
      );
      values.append(
        "contact",
        updatedValues.contact ? updatedValues.contact : ""
      );
      values.append(
        "billing_address",
        updatedValues.billing_address ? updatedValues.billing_address : ""
      );
      values.append(
        "pincode",
        updatedValues.pincode ? updatedValues.pincode : ""
      );
      updatedValues.vendor_type &&
        values.append("vendor_type", updatedValues.vendor_type);
      // values.append(
      //   "vendor_type",
      //   updatedValues.vendor_type ? updatedValues.vendor_type : ""
      // );

      values.append(
        "category",
        updatedValues.category ? updatedValues.category : ""
      );
      // updatedValues?.category?.map((b) => {
      //   values.append("category", b);
      // });
      values.append(
        "optional_contact1",
        updatedValues.optional_contact1 ? updatedValues.optional_contact1 : ""
      );
      values.append(
        "optional_contact2",
        updatedValues.optional_contact2 ? updatedValues.optional_contact2 : ""
      );
      values.append(
        "optional_email1",
        updatedValues.optional_email1 ? updatedValues.optional_email1 : ""
      );
      values.append(
        "optional_email2",
        updatedValues.optional_email2 ? updatedValues.optional_email2 : ""
      );
      values.append(
        "optional_contact_name1",
        updatedValues.optional_contact_name1
          ? updatedValues.optional_contact_name1
          : ""
      );
      values.append(
        "optional_contact_name2",
        updatedValues.optional_contact_name2
          ? updatedValues.optional_contact_name2
          : ""
      );

      values.append(
        "pan_number",
        updatedValues.pan_number ? updatedValues.pan_number : ""
      );
      values.append(
        "organisation",
        props.settings?.user?.organisation?.organisation_id
      );
      values.append("branch", props?.settings?.branch?.id);
      values.append("gst", updatedValues.gst ? updatedValues.gst : "");
      values.append("email", updatedValues.email ? updatedValues.email : "");
      values.append(
        "contact_person",
        updatedValues.contact_person ? updatedValues.contact_person : ""
      );
      values.append(
        "billing_address",
        updatedValues.billing_address ? updatedValues.billing_address : ""
      );
      values.append(
        "bank_ifsc",
        updatedValues.bank_ifsc ? updatedValues.bank_ifsc : ""
      );
      values.append(
        "bank_account_number",
        updatedValues.bank_account_number
          ? updatedValues.bank_account_number
          : ""
      );
      values.append(
        "bank_account_holder",
        updatedValues.bank_account_holder
          ? updatedValues.bank_account_holder
          : ""
      );
      if (editId) {
        axios
          .put(`${VendorApi}${editId}/`, values)
          .then((res) => {
            toast.success("Vendor Edited Successfully!");
            onClose();
            fetchVendors();
          })
          .catch((res) => {
            toast.error("Something went wrong!");
          });
      } else {
        axios
          .post(`${VendorApi}`, values)
          .then((res) => {
            toast.success("Vendor Added Successfully!");
            onClose();
            fetchVendors();
          })
          .catch((res) => {
            toast.error("Something went wrong!");
          });
      }
    } else {
      toast.error("Enter Required Fields");
    }
  };
  const onUpdate = (id, data) => {
    setEditId(id);
    setVisible(true);
    logger.log(LogEvents.submitVendorEditDetail, {});
    axios.get(`apiV1/vendor/${id}/`).then((res) => {
      console.log("res.data ", res.data);
      if (
        res.data?.gst ||
        res.data?.pan_number ||
        res.data?.bank_account_holder ||
        res.data?.bank_account_number ||
        res.data?.bank_ifsc ||
        res.data?.billing_address
      ) {
        setFinancial(true);
      }
      formRef.current.setFieldsValue({
        name: res.data.name,
        contact: res.data.contact,
        email: res.data.email,
        category:
          data?.category?.length > 0 ? data?.category[0]?.category_name : "",
        pincode: res.data.pincode ? res.data.pincode : "",
        billing_address: res.data.billing_address
          ? res.data.billing_address
          : "",
        // vendor_type: res.data.vendor_type ? res.data.vendor_type : "",
        contact_person: res.data.contact_person ? res.data.contact_person : "",
        gst: res.data.gst ? res.data.gst : "",
        pan_number: res.data.pan_number ? res.data.pan_number : "",
        bank_account_holder: res.data.bank_account_holder
          ? res.data.bank_account_holder
          : "",
        bank_account_number: res.data.bank_account_number
          ? res.data.bank_account_number
          : "",
        bank_ifsc: res.data.bank_ifsc ? res.data.bank_ifsc : "",
        billing_address: res.data.billing_address
          ? res.data.billing_address
          : "",
        optional_contact1: res.data.optional_contact1 ?? "",
        optional_contact2: res.data.optional_contact2 ?? "",
        optional_email1: res.data.optional_email1 ?? "",
        optional_email2: res.data.optional_email2 ?? "",
        optional_contact_name1: res.data.optional_contact_name1 ?? "",
        optional_contact_name2: res.data.optional_contact_name2 ?? "",
        vendor_type: res.data.vendor_type ?? null,
      });
      // setTags(res.data?.vendor_type ? JSON.parse(res.data?.vendor_type) : []);
      // childRef.current.setVal(JSON.parse(res.data?.vendor_type))
      // console.log()
      // childRef.current.changeVal(JSON.parse(res.data?.vendor_type))
    });
  };
  useEffect(() => {
    logger.log(LogEvents.vendors, {});
    fetchVendors();
    fetchcategories();
  }, []);

  const categoryOptions = categories?.map((each) => (
    <Option key={each?.id} value={each?.id}>
      {each?.category_name}
    </Option>
  ));
  function uploadVendorData(e) {
    logger.log(LogEvents.bulkUploadVendor, {});

    var items = e;
    const formValue = new FormData();
    formValue.append(
      "organisation",
      props.settings?.user?.organisation?.organisation_id
    );
    formValue.append("branch", props?.settings?.branch?.id);
    formValue.append("file", items, items.name);
    axios
      .post(`${BulkUploadVendorApi}`, formValue)
      .then((res) => {
        toast.success("Vendors added successfully!");
        setModal1Visible(false);
        fetchVendors();
      })
      .catch((err) => {
        if (err.response.status === 500) {
          toast.error("Format does not match as what is required");
        }
      });
  }
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const searchInput = useRef(null);

  const onDelete = (id) => {
    setLoading(true);
    axios
      .delete(`${VendorApi}${id}/`)
      .then((res) => {
        toast.success("Vendor Deleted Successfully!");
        fetchVendors();
      })
      .catch((res) => {
        toast.error("Something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={
            ("pincode" ? String(text).replace(/\..*$/, "") : text)
              ? ("pincode"
                  ? String(text).replace(/\..*$/, "")
                  : text
                ).toString()
              : ""
          }
        />
      ) : dataIndex === "pincode" ? (
        String(text).replace(/\..*$/, "")
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Vendor Name",
      key: "name",
      dataIndex: "name",
      fixed: "left",
      // ...getColumnSearchProps("name"),
    },
    {
      title: "Vendor code",
      key: "vendor_code",
      dataIndex: "vendor_code",
      // ...getColumnSearchProps('vendor_code'),
      // filters: filterValues["vendor_code"],
      // onFilter: (value, record) => record.vendor_code.indexOf(value) === 0,
    },
    {
      title: "Vendor Categories",
      key: "category",
      render: (data) => (
        <span className="text-capitalize" style={{ fontWeight: "normal" }}>
          {data?.category?.map(
            (each) =>
              each?.category_name?.length !== 0 && (
                <Tag color="blue">{each?.category_name}</Tag>
              )
          )}
        </span>
      ),
      width: 180,
      // filters: filterValues["vendor_categories"],
      // onFilter: (value, record) =>
      //   record.category.find((cat) => cat.category_name === value),
    },
    {
      title: "Contact Person",
      key: "contact_person",
      dataIndex: "contact_person",
      // ...getColumnSearchProps("contact_person"),
    },
    {
      title: "Mobile Number",
      key: "contact",
      dataIndex: "contact",
      // ...getColumnSearchProps("contact"),
    },
    {
      title: "Email Id",
      key: "email",
      dataIndex: "email",
      // ...getColumnSearchProps('email'),
      // filters: filterValues["email_id"],
      // onFilter: (value, record) => record.email.indexOf(value) === 0,
    },
    {
      title: "Billing Address",
      key: "billingAddress",
      dataIndex: "billing_address",
      // ...getColumnSearchProps("billing_address"),
    },
    {
      title: "Pincode",
      key: "pincode",
      dataIndex: "pincode",
      render: (data) => {
        return String(data).replace(/\..*$/, "");
      },
      // ...getColumnSearchProps('pincode'),
      // filters: filterValues["pincode"],
      // onFilter: (value, record) => record.pincode.indexOf(value) === 0,
    },
    {
      title: "Actions",
      key: "action",
      render: (data) => (
        <Space>
          <Tag
            onClick={() => {
              setSelectedVendorCatalogue(data);
            }}
            color="blue"
            role="button"
          >
            Manage Catalogues
          </Tag>
          <Tag
            onClick={() => {
              logger.log(LogEvents.editVendorDetails, {});
              onUpdate(data.id, data);
            }}
            color={"warning"}
          >
            Edit Details
          </Tag>
          <Popconfirm
            title="Are you sure to delete this vendor?"
            onConfirm={() => onDelete(data.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tag color="error">Delete</Tag>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const [userSelectedColumns, setUserSelectedColumns] = useState(
    props.settings?.user?.user_selected_columns?.vendor_table ?? columns
  );

  useEffect(() => {
    if (props.settings?.user?.user_selected_columns?.vendor_table) {
      const columnSettings = userSelectedColumns?.map((col) => {
        let currentCol =
          props.settings?.user?.user_selected_columns?.vendor_table?.find(
            (column) => col.key == column?.key
          );
        return { ...col, selected: currentCol?.selected ?? true };
      });
      setUserSelectedColumns(columnSettings);
    }
  }, [props.settings?.user?.user_selected_columns?.vendor_table]);

  const getUserSelectedColumns = () => {
    return userSelectedColumns
      .filter((column) => {
        return column?.selected !== false;
      })
      .map((column) => {
        return columns.find((col) => col.key === column.key);
      });
  };

  const copySharableLink = async () => {
    const response = await axios.get("apiV1/generate-otp-vendor-onbaording/");
    navigator.clipboard.writeText(
      `${window.location.host}/open-vendor/${props.settings?.user?.organisation?.organisation__name}/${response.data}/${props.settings?.user?.organisation?.organisation_id}`
    );
    toast.success("Sharable link copied to clipboard!");
  };

  const addVendorToBranch = (vendorData) => {
    setVisible(true);
    setTimeout(() => {
      formRef.current.setFieldsValue({
        ...vendorData,
      });
    }, 300);
  };

  // useEffect(() => {
  //   // Create a set for all the vendor categories
  //   const vendorCategories = new Set();
  //   vendorList.forEach((vendor) => {
  //     vendor.category.forEach((category) => {
  //       vendorCategories.add(category.category_name);
  //     });
  //   });
  //   const vendorCode = new Set();
  //   vendorList.forEach((vendor) => {
  //     vendorCode.add(vendor.vendor_code);
  //   });

  //   setFilterValues({
  //     ...filterValues,
  //     vendor_categories: Array.from(vendorCategories).map((category) => {
  //       if (category === "") {
  //         return {
  //           text: "Not Specified",
  //           value: "",
  //         };
  //       }
  //       return {
  //         text: category,
  //         value: category,
  //       };
  //     }),
  //     vendor_code: Array.from(vendorCode).map((code) => {
  //       if (code === "") {
  //         return {
  //           text: "Not Specified",
  //           value: "",
  //         };
  //       }
  //       return {
  //         text: code,
  //         value: code,
  //       };
  //     }),
  //     email_id: Array.from(
  //       new Set(vendorList.map((vendor) => vendor.email))
  //     ).map((email) => {
  //       if (email === "") {
  //         return {
  //           text: "Not Specified",
  //           value: "",
  //         };
  //       }
  //       return {
  //         text: email,
  //         value: email,
  //       };
  //     }),
  //     pincode: Array.from(
  //       new Set(vendorList.map((vendor) => vendor.pincode))
  //     ).map((pincode) => {
  //       if (pincode === "") {
  //         return {
  //           text: "Not Specified",
  //           value: "",
  //         };
  //       }
  //       return {
  //         text: pincode,
  //         value: pincode,
  //       };
  //     }),
  //   });
  // }, [vendorList.length]);

  const onVendorPageChange = (page) => {
    console.log("debug>>>");
    setVendorSearchParams({
      ...vendorSearchParams,
      page: page,
    });
    fetchVendors({ page });
  };

  return (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="">
                <H5>All Vendors</H5>
              </div>
              <span className="d-flex"></span>
              <Space>
                <Space>
                  <span>
                    Empanelled Vendors :{" "}
                    <Switch
                      style={{ marginLeft: 10 }}
                      checked={!empaneled}
                      onChange={(e) => {
                        logger.log(LogEvents.empaneledVendors, {});
                        setEmpaneled(!e);
                      }}
                    />
                  </span>
                </Space>
                {vendorCreationAndEditGranted(props?.settings?.user) && (
                  <>
                    <Button
                      onClick={(e) => {
                        logger.log(LogEvents.addVendor, {});
                        showDrawer();
                      }}
                      className="btn btn-primary d-flex align-items-center justify-content-center text-white"
                    >
                      {" "}
                      <PlusCircle />
                      <div
                        style={{
                          marginLeft: "4px",
                          paddingTop: "4px",
                          paddingBottom: "4px",
                        }}
                      >
                        Add Vendor
                      </div>
                    </Button>
                  </>
                )}

                {/* <Dropdown.Button
                  overlay={
                    <Menu
                      // onClick={handleMenuClick}
                      items={[
                        {
                          label: "Vendor Settings",
                          key: "1",
                          // icon: <UserOutlined />,
                        },
                        {
                          label: "Switch to Financial Mode",
                          key: "2",
                          // icon: <UserOutlined />,
                        },
                      ]}
                    />
                  }
                  icon={<EllipsisOutlined />}
                /> */}
                {!empaneled ? (
                  <ColumnConfig
                    columns={userSelectedColumns}
                    setCols={(cols) => setUserSelectedColumns(cols)}
                    onClick={() => {
                      logger.log(LogEvents.customizeVendorMenu, {});
                    }}
                    mode="vendor"
                  />
                ) : (
                  <Settings />
                )}
              </Space>
            </div>
            <div className="my-2 d-flex justify-content-between">
              {/* {!empaneled && (
                <Col sm={6}>
                  <Search placeholder="Search vendors" onSearch={onSearch} />
                </Col>
              )} */}
              <Col sm={empaneled ? 24 : 17}>
                <SearchFilterDirectory
                  fetchVendors={fetchVendorsDirectory}
                  setEmpaneled={setEmpaneled}
                  empaneled={empaneled}
                  setTotalPages={setTotalPages}
                  pages={totalPages}
                  setHeadPinCode={setHeadPinCode}
                  setHeadkm={setHeadkm}
                  setSelectedCategories={setSelectedCategories}
                />
                {!empaneled && (
                  <VendorSearch
                    searchParams={vendorSearchParams}
                    setSearchParams={setVendorSearchParams}
                    onSearch={onSearch}
                  />
                )}
              </Col>
            </div>
            <div className="my-2">
              {empaneled ? (
                <EmpaneledVendors
                  empaneled={empaneled}
                  vendorList={vendorListEmpaneled}
                  pages={totalPages}
                  addVendorToBranch={addVendorToBranch}
                  fetchVendors={fetchVendorsDirectory}
                  setSelectedVendor={setSelectedVendor}
                />
              ) : (
                <>
                  <Table
                    loading={loading}
                    dataSource={vendorList}
                    columns={getUserSelectedColumns()}
                    pagination={{
                      position: ["bottomRight"],
                      defaultPageSize: 10,
                      total: totalVendorPages,
                      onChange: onVendorPageChange,
                      showSizeChanger: false,
                      current: vendorSearchParams.page,
                    }}
                    scroll={{
                      x: "100%",
                      y: getTableHeight({ table_name: "vendor_table" }),
                    }}
                  />
                  {/* <Row justify="end mt-2">
                    <Pagination
                      defaultCurrent={currentPage}
                      total={totalVendors}
                      showTotal={(total) => `Total ${total} items`}
                      onChange={onPageChange}
                    />
                  </Row> */}
                </>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
      <Drawer
        title="Vendor details"
        placement="right"
        visible={selectedVendor}
        onClose={() => setSelectedVendor(false)}
        width={700}
      >
        <VendorDetails {...selectedVendor} />
      </Drawer>
      <Drawer
        title={editId ? "Edit Vendor" : "Add Vendor"}
        width={500}
        onClose={() => {
          onClose();
        }}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onClose();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="vendorForm"
              type="primary"
              // htmlType="submit"
              onClick={AddVendor}
            >
              Submit
            </Button>
          </div>
        }
      >
        <div className="px-3 text-center">
          <StyledDropzone setFile={uploadVendorData} />
          <strong>
            <a
              href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Vendor_Sample.xlsx"
              download
              onClick={() => {
                logger.log(LogEvents.downloadVendorExample, {});
              }}
            >
              Download Example
            </a>
          </strong>
        </div>
        <Form
          layout="vertical"
          id="vendorForm"
          ref={formRef}
          // onFinish={AddVendor}
        >
          <Row justify="space-between" className="py-2">
            <strong
              className="align-items-center d-flex"
              style={{ fontSize: "16px" }}
            >
              Basic Details
            </strong>
            <Button onClick={copySharableLink} type="link">
              Get sharable link
            </Button>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"name"}
                label="Vendor Business Name"
                rules={[
                  {
                    required: true,
                    message: "Vendor Business Name is required",
                  },
                ]}
              >
                <Input placeholder="e.g. MDepot Furnishings" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"vendor_type"} label="Vendor Type">
                <Select placeholder="Select Vendor Type">
                  <Option value="supplier">Supplier</Option>
                  <Option value="contractor">Contractor</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              {/* <Form.Item
                name={"category"}
                rules={[
                  {
                    required: true,
                    message: "Vendor Business Name is required",
                  },
                ]}
                label="Category"
              >
                <Select mode="multiple" placeholder="Select Category">
                  {categoryOptions}
                </Select>
              </Form.Item> */}

              <Form.Item name={"category"} label="Category">
                <Input placeholder="e.g. Laminates" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"contact_person"}
                label="Contact person name"
                rules={[
                  {
                    pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                    message: "Enter valid person name",
                  },
                ]}
              >
                <Input placeholder="Contact person name" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"vendor_code"}
                label="Vendor Code"
                rules={[
                  {
                    required: true,
                    message: "Vendor Code is required",
                  },
                ]}
              >
                <Input placeholder="Vendor Code" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"contact"}
                label="Phone Number"
                rules={[
                  {
                    required: true,
                    pattern: /^[1-9]\d{9}$/gi,
                    message: "Phone Number is required",
                  },
                ]}
              >
                <Input placeholder="Phone Number" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"email"}
                label="Email"
                rules={[
                  {
                    required: true,
                    pattern:
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Email is required",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"billing_address"} label="Address">
                <Input placeholder="Enter your billing address here." />
              </Form.Item>
            </Col>
          </Row>{" "}
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    required: true,
                    pattern: /^[1-9]\d{5}$/gi,

                    message: "Enter a valid pincode",
                  },
                ]}
              >
                <Input placeholder="Enter your pincode here" />
              </Form.Item>
            </Col>
          </Row>
          <strong
            className="pb-2 d-flex align-items-center"
            style={{ fontSize: "16px" }}
          >
            <div style={{ marginRight: 15 }}>Contact Details</div>
            <Switch
              checked={showContactDetails}
              onChange={(e) => {
                setShowContactDetails(e);
              }}
            />
          </strong>
          {showContactDetails && (
            <>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name="optional_email1"
                    label="Optional Email #1"
                    rules={[
                      {
                        pattern:
                          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: "Email must be valid",
                      },
                    ]}
                  >
                    <Input placeholder="Optional Email #1" />
                  </Form.Item>
                </Col>

                <Col sm={12}>
                  <Form.Item
                    name="optional_email2"
                    label="Optional Email #2"
                    rules={[
                      {
                        pattern:
                          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: "Email must be valid",
                      },
                    ]}
                  >
                    <Input placeholder="Optional Email #2" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name="optional_contact1"
                    label="Optional Contact #1"
                    rules={[
                      {
                        pattern: /^[1-9]\d{9}$/gi,
                        message: "Phone Number must be valid",
                      },
                    ]}
                  >
                    <Input placeholder="Optional Contact #1" />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name="optional_contact2"
                    label="Optional Contact #2"
                    rules={[
                      {
                        pattern: /^[1-9]\d{9}$/gi,
                        message: "Phone Number must be valid",
                      },
                    ]}
                  >
                    <Input placeholder="Optional Contact #2" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name="optional_contact_name1"
                    label="Optional Contact Person #1"
                  >
                    <Input placeholder="Optional Contact Person #1" />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name="optional_contact_name2"
                    label="Optional Contact Person #2"
                  >
                    <Input placeholder="Optional Contact Person #2" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <strong
            className="pb-2 d-flex align-items-center"
            style={{ fontSize: "16px" }}
          >
            <div style={{ marginRight: 15 }}>Financial Details</div>
            <Switch
              checked={financial}
              onChange={(e) => {
                setFinancial(e);

                logger.log(LogEvents.addFinancialDetails, {});
              }}
            />
          </strong>
          {financial ? (
            <>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name={"bank_account_number"}
                    label="Bank Account Number"
                    rules={[
                      {
                        pattern: /^[0-9]{9,18}$/,
                        message: "Enter valid Bank account number",
                      },
                    ]}
                  >
                    <Input placeholder="Bank Account Number" />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name={"bank_account_holder"}
                    label="Bank Holder Name"
                  >
                    <Input placeholder="Bank Holder Name" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name={"bank_ifsc"}
                    label="IFSC Code"
                    rules={[
                      {
                        pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: "Enter valid IFSC code",
                      },
                    ]}
                  >
                    <Input placeholder="IFSC Code" />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item name={"billing_address"} label="Billing Address">
                    <Input placeholder="Billing Address" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col sm={12}>
                  <Form.Item
                    name={"gst"}
                    label="GST Number"
                    rules={[
                      {
                        pattern:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Enter valid GST Number",
                      },
                    ]}
                  >
                    <Input
                      placeholder="GST Number"
                      // After the user is done typing, try to extract the PAN number
                      // from the GST number
                      onBlur={(e) => {
                        const gst = e.target.value;
                        if (gst.length === 15) {
                          const pan = gst.slice(2, 12);
                          formRef.current?.setFieldsValue({
                            pan_number: pan,
                          });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col sm={12}>
                  <Form.Item
                    name={"pan_number"}
                    label="PAN Number"
                    rules={[
                      {
                        pattern: /[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        message: "Enter valid PAN Number",
                      },
                    ]}
                  >
                    <Input placeholder="PAN Number" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : null}
        </Form>
      </Drawer>

      <VendorCatalogue
        open={Boolean(selectedVendorCatalogue)}
        onClose={() => setSelectedVendorCatalogue(null)}
        vendor={selectedVendorCatalogue}
      />

      <Modal
        title="Add Bulk Vendors"
        centered
        visible={modal1Visible}
        width="600px"
        onCancel={() => {
          setModal1Visible(false);
        }}
        footer={null}
      >
        <div className="px-3">
          <StyledDropzone setFile={uploadVendorData} />
          {/* <Dragger
            beforeUpload={() => false}
            {...draggerprops}
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "400px" }}
          >
            <div className="text-center">
              Drag and drop your file here, or click to select.
            </div>
          </Dragger> */}
          <a
            href="https://material-depot-content-files.s3.ap-south-1.amazonaws.com/Mysite/Vendor_Sample.xlsx"
            download
          >
            Download Example
          </a>
        </div>
      </Modal>
      <Modal
        title="Vendor Upload Result"
        centered
        visible={modal2Visible}
        width="600px"
        onCancel={() => {
          setModal2Visible(false);
        }}
        footer={null}
      >
        <UploadResultTable data={excelData} />
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(Vendor);
